import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  ReactNode,
} from "react";

interface NetworkProviderProps {
  children: ReactNode;
}

const NetworkContext = createContext<boolean>(navigator.onLine);

export const useNetwork = () => useContext(NetworkContext);

export const NetworkProvider: React.FC<NetworkProviderProps> = ({
  children,
}) => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  // const [intervalId, setIntervalId] = useState<number | undefined>();

  useEffect(() => {
    const checkNetworkStatus = () => {
      setIsOnline(navigator.onLine);
    };

    const newIntervalId = window.setInterval(
      checkNetworkStatus,
      isOnline ? 10000 : 3000
    );
    // setIntervalId(newIntervalId);

    return () => {
      if (newIntervalId) {
        window.clearInterval(newIntervalId);
      }
    };
  }, [isOnline]);

  useEffect(() => {
    const handleOnline = () => {
      console.log("Online!");
      setIsOnline(true);
    };

    const handleOffline = () => {
      console.log("Offline!");
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <NetworkContext.Provider value={isOnline}>
      {children}
    </NetworkContext.Provider>
  );
};
